// extracted by mini-css-extract-plugin
module.exports = {"Title":"List__Title_URC--","Description":"List__Description_3cW2n"};